module.exports = __webpack_public_path__ + "hero-unselect.213ebcaf.png";